{
  "until": "{{duration}} حتى {{prayer}}",
  "begin_focus": "ابدأ التركيز",
  "add_task": "أضف مهمة",
  "more_tasks": "+{{count}} أخرى",
  "fajr_at": "الفجر في {{time}}",
  "schedule_title": "اليوم",
  "plan_my_day": "خطّط يومي",
  "planning": "جارٍ التخطيط…",
  "suggested": "مقترح",
  "keep_plan": "اعتمد الخطة",
  "undo_plan": "تراجع",
  "plan_error": "تعذّر التخطيط الآن. حاول مجددًا.",
  "plan_empty": "لا شيء للتخطيط بعد — أضف مهمة أولاً.",
  "plan_settled": "كل شيء في مكانه بالفعل.",
  "view_list": "القائمة",
  "view_switch_aria": "التبديل بين عرض القائمة وعرض اليوم",
  "unassigned": "غير مجدولة",
  "assign_title": "فترة الصلاة",
  "no_block": "بدون فترة",
  "assign_aria": "إسناد إلى فترة صلاة",
  "open_schedule_aria": "فتح جدول اليوم",
  "focus_session_label": "{{block}} · تركيز",
  "block_hero": "عمل عميق حتى {{prayer}}",
  "moments_away": "{{prayer}} بعد لحظات",
  "block_clear": "كل شيء منجز — استرح حتى {{prayer}}",
  "alhamdulillah": "الحمد لله",
  "exit_hint": "اضغط Esc للخروج بهدوء",
  "exit_hint_touch": "اضغط ✕ للخروج بهدوء",
  "mark_done_aria": "وضع علامة إتمام على المهمة",
  "quick_add_placeholder": "أضف إلى هذه الفترة…",
  "focus_task_aria": "التركيز على هذه المهمة"
}
